import { __assign, __rest } from "tslib";
/**@jsx jsx */

import { View } from './View';
import { Text } from './Text';
import { useUid } from './hooks';
import { jsx } from '@emotion/react';
import { useTheme } from './theme/Providers';
import CheckIcon from './icons/static/check-icon.svg';
import DarkCheckIcon from './icons/static/dark-check-icon.svg';

var Check = function Check(_a) {
  var _b;

  var type = _a.type,
      label = _a.label,
      labelStyles = _a.labelStyles,
      labelTextStyles = _a.labelTextStyles,
      id = _a.id,
      disabled = _a.disabled,
      checkPositionRight = _a.checkPositionRight,
      description = _a.description,
      labelIcon = _a.labelIcon,
      descriptionStyles = _a.descriptionStyles,
      labelIconStyles = _a.labelIconStyles,
      textContainerStyles = _a.textContainerStyles,
      simulador = _a.simulador,
      mainContainerStyles = _a.mainContainerStyles,
      other = __rest(_a, ["type", "label", "labelStyles", "labelTextStyles", "id", "disabled", "checkPositionRight", "description", "labelIcon", "descriptionStyles", "labelIconStyles", "textContainerStyles", "simulador", "mainContainerStyles"]);

  var uid = useUid(id);
  var theme = useTheme();
  var isNotRadioButton = type !== 'radio';
  var isDarkMode = theme.colors.mode === 'dark';

  var checkStateStyles = function () {
    var gray = isNotRadioButton ? theme.colors.scales.grayShades[3] : theme.colors.scales.grayShades[4];
    return {
      disableBaseStyles: {
        border: "0.063rem solid ".concat(isDarkMode ? theme.colors.scales.grayShades[8] : gray),
        backgroundColor: isDarkMode ? theme.colors.scales.grayShades[8] : gray
      },

      get checked() {
        return {
          backgroundColor: isDarkMode ? theme.colors.scales.blue[3] : theme.colors.palette.blue.base,
          border: "0.063rem solid ".concat(isDarkMode ? theme.colors.scales.blue[3] : theme.colors.palette.blue.base),
          backgroundImage: "url(\"".concat(isDarkMode ? DarkCheckIcon : CheckIcon, "\")"),
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center'
        };
      },

      get hover() {
        return {
          ':checked + label:before': {
            border: "0.063rem solid ".concat(isDarkMode ? theme.colors.scales.blue[2] : theme.colors.palette.blue.light),
            backgroundColor: isDarkMode ? theme.colors.scales.blue[2] : theme.colors.palette.blue.light
          }
        };
      },

      get focus() {
        return {
          ':checked + label:before': {
            border: "0.063rem solid ".concat(isDarkMode ? theme.colors.scales.blue[1] : theme.colors.palette.blue.dark),
            backgroundColor: isDarkMode ? theme.colors.scales.blue[1] : theme.colors.palette.blue.dark
          }
        };
      },

      get disabled() {
        return {
          ':checked + label:before': __assign(__assign({}, this.disableBaseStyles), {
            'hover': __assign({}, this.disableBaseStyles)
          })
        };
      }

    };
  }();

  return jsx("div", {
    className: 'Check',
    css: __assign({
      display: 'flex',
      alignItems: 'center',
      width: '100%'
    }, mainContainerStyles)
  }, jsx("input", __assign({
    disabled: disabled,
    className: 'Check__input',
    type: type || 'checkbox',
    id: uid,
    css: {
      opacity: 0,
      position: 'absolute',
      ':checked + label:before': checkStateStyles.checked,
      ':hover': checkStateStyles.hover,
      ':focus': checkStateStyles.focus,
      ':disabled': checkStateStyles.disabled
    }
  }, other)), jsx("label", {
    className: 'Check__label_wrapper',
    css: __assign({
      alignItems: 'center',
      display: 'flex',
      justifyContent: checkPositionRight ? 'space-between' : undefined,
      flexDirection: checkPositionRight ? 'row-reverse' : undefined,
      width: 'inherit',
      ':disabled': {
        color: theme.colors.scales.grayShades[8]
      },
      ':before': {
        border: "0.063rem solid ".concat(isDarkMode ? theme.colors.scales.grayShades[7] : theme.colors.scales.grayShades[8]),
        borderRadius: isNotRadioButton ? theme.radii.xs : theme.radii.xl,
        content: '" "',
        width: theme.iconSizes.lg,
        height: theme.iconSizes.lg,
        margin: !checkPositionRight ? theme.spaces.xs : undefined
      }
    }, labelStyles),
    htmlFor: uid
  }, simulador ? null : jsx(View, {
    css: __assign((_b = {}, _b["@media (max-width: ".concat(theme.breakpoints.sm, ")")] = {
      flexBasis: '80%'
    }, _b), textContainerStyles)
  }, jsx(Text, {
    css: __assign({
      color: theme.colors.scales.grayShades[11]
    }, labelTextStyles),
    variant: description ? 'subtitle' : 'paragraph',
    className: 'Check__label'
  }, labelIcon && jsx(View, {
    className: 'Check__label__icon',
    variant: 'span',
    role: 'img',
    "aria-label": label,
    css: __assign({
      display: 'inline-block',
      marginRight: theme.spaces.sm,
      width: theme.iconSizes.md,
      height: theme.iconSizes.md,
      boxSizing: 'border-box'
    }, labelIconStyles)
  }, labelIcon), label), description && jsx(Text, {
    variant: 'paragraph',
    className: 'Check__label__description',
    css: __assign({
      color: theme.colors.scales.grayShades[7]
    }, descriptionStyles)
  }, description))));
};

export { Check };